import React from 'react';
import { Modal, Select, Input, Form } from 'antd';
import { useErrorTopicIdOptions } from '../../../../hooks/useErrorTopic';

const { TextArea } = Input;

const AuditReportModal = ({ visible, onClose, onConfirm }) => {
    const [form] = Form.useForm();
    // หัวข้อเคสผิดพลาด มาจาก master data (admin > Master Data > Error Topic)
    // เดิมดึงจาก enums type 6 ซึ่งเป็นคนละชุดกับหน้า Manual DEP ตอนนี้รวมเป็นชุดเดียวแล้ว
    const { options: listReason } = useErrorTopicIdOptions();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            onConfirm(values);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="Audit Report"
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Confirm"
            cancelText="Cancel"
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="auditRemarkType"
                    label="Reason"
                    rules={[{ required: true, message: 'Please select a reason' }]}
                >
                    <Select placeholder="Select a reason" options={listReason} />
                </Form.Item>
                <Form.Item
                    name="auditRemark"
                    label="รายละเอียด"
                    rules={[{ required: false, message: 'Please enter a note' }]}
                >
                    <TextArea rows={4} placeholder="Enter note..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AuditReportModal;
